// 項目の意味（説明文）— 表示専用の参照テキスト。管理者が設定を変えるまでキャッシュする。
import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/doc-ai/field-meanings`;
const cache = new Map();
const inflight = new Map();

export const invalidateFieldMeanings = () => { cache.clear(); inflight.clear(); };

const fetchMeanings = (profileKey, language) => {
  const key = `${profileKey || '*'}|${language}`;
  if (cache.has(key)) return Promise.resolve(cache.get(key));
  if (inflight.has(key)) return inflight.get(key);
  const params = { language };
  if (profileKey) params.profile_key = profileKey;
  const p = axios.get(API, { params })
    .then((r) => {
      const rows = r.data?.meanings || {};
      cache.set(key, rows);
      return rows;
    })
    .catch(() => ({}))   // 意味が取れなくてもレビューは止めない
    .finally(() => inflight.delete(key));
  inflight.set(key, p);
  return p;
};

/** 意味の辞書 { field_key: {meaning, source, source_label_ja} } を返す。 */
export const useFieldMeanings = (profileKey, language = 'ja') => {
  const [rows, setRows] = useState(() => cache.get(`${profileKey || '*'}|${language}`) || {});
  useEffect(() => {
    let alive = true;
    fetchMeanings(profileKey, language).then((r) => { if (alive) setRows(r); });
    return () => { alive = false; };
  }, [profileKey, language]);
  return rows;
};

export default useFieldMeanings;
